<div style="position: relative; /* or absolute */
top: 0%;
left: 1%;
width: 97%;">
  <div class="col-xs-12">
    <div [hidden]="submitted">
      <form (ngSubmit)="onSubmit()" #userForm="ngForm">
        <div class="d-flex align-items-center justify-content-between mb-4">
          <div class="d-flex align-items-center gap-3">
            <app-user-avatar [user]="user" size="lg"></app-user-avatar>
            <h2 class="mb-0">{{user.username}}</h2>
          </div>
          <div class="d-flex gap-2">
            <button class="btn btn-primary" (click)="goToList()">{{'FUNCTION-BUTTONS.CANCEL' | translate}}</button>
            <button type="submit" class="btn btn-primary"
              [disabled]="!userForm.form.valid || user.roles===undefined || user?.roles?.length===0 || (!user.id && (userForm.form.valid && (user.id || (pass2==='' || pass1===''|| pass1!==pass2))))">{{'FUNCTION-BUTTONS.SAVE' | translate}}
            </button>
          </div>
        </div>
        <!-- <div class="form-group">
        <label for="username">{{'USER.USERNAME' | translate}}</label>
        <input type="text" class="form-control" id="username" [(ngModel)]="user.username" name="username" #username="ngModel" required>
        <div [hidden]="name.valid || name.pristine" class="alert alert-danger">
          {{'USER.USERNAME_REQUIRED' | translate}}
        </div>
        <div *ngIf="usernameExists" style="color:red">{{'ERROR.USERNAME_EXISTS' | translate}}</div>
      </div> -->


      <div class="form-group mb-4">
        <label for="name">{{'USER.FIRSTNAME' | translate}}</label>
        <input type="text" class="form-control" id="name" [(ngModel)]="user.name" name="name" #name="ngModel">
      </div>

      <div class="form-group mb-4">
        <label for="surname">{{'USER.LASTNAME' | translate}}</label>
        <input type="text" class="form-control" id="surname" [(ngModel)]="user.surname" name="surname"
          #surname="ngModel">
        </div>

        @if (isAdmin) {
          <div class="mb-4"
            style="border: 1px red solid; width: 400px; padding: 10px; border-radius: 6px;">
            <span>{{'USER.STATUS' | translate}}:</span>
            <div class="form-check form-switch mt-1">
              <input mdbCheckbox class="form-check-input" type="checkbox" id="status" name="status"
                [checked]="user.status === 'ENABLED'" (change)="onChangestatus($event)" />
                <label class="form-check-label" for="flexCheckDefault">
                  - {{'USER.ACTIVE' | translate}}
                </label>
              </div>
            </div>

            <!--
              Two-factor status, for local accounts. `mfaEnrolled`/`mfaMethod` are
              derived server-side by sanitizeUser(); the secret itself never
              crosses the API. Resetting does not weaken the account -- MFA stays
              mandatory, so the user's next sign-in goes to enrolment.
            -->
            @if (user.id) {
              <div class="mb-4" style="width: 400px; padding: 10px; border: 1px solid var(--border-strong); border-radius: 6px;">
                <span class="fw-semibold">{{ 'AUTH.MFA_STATUS' | translate }}:</span>
                <div class="mt-1">
                  @if (user.mfaEnrolled) {
                    @if (user.mfaMethod === 'email') {
                      {{ 'AUTH.MFA_ENROLLED_EMAIL' | translate }}
                    } @else {
                      {{ 'AUTH.MFA_ENROLLED_TOTP' | translate }}
                    }
                  } @else {
                    {{ 'AUTH.MFA_NOT_ENROLLED_LABEL' | translate }}
                  }
                </div>
                @if (user.mfaEnrolled) {
                  <button type="button" class="btn btn-outline-danger btn-sm mt-2"
                          [disabled]="mfaResetBusy" (click)="resetMfa()">
                    {{ 'AUTH.MFA_RESET' | translate }}
                  </button>
                }
              </div>
            }
          }

          <div class="mb-4">
            <label class="fw-semibold">{{'USER.ROLES' | translate}}</label>
            @if (!isAdmin) {
              <div class="d-flex flex-wrap gap-2 mt-1">
                @for (role of user.roles; track role) {
                  <span
                    class="badge rounded-pill bg-secondary"
                    style="font-size: 0.8rem; padding: 6px 12px; letter-spacing: 0.03em;">
                    {{ formatRole(role) }}
                  </span>
                }
              </div>
            }
          </div>
          @if (isAdmin) {
            <div class="mb-4">
              <div class="form-check form-switch">
                <input mdbCheckbox class="form-check-input" type="checkbox" value="'ADMIN'" id="admin" name="admin"
                  [checked]="user?.roles && user?.roles.includes('ADMIN')" (change)="onCheckboxChange($event,'ADMIN')" />
                  <label class="form-check-label" for="flexCheckDefault">
                    - {{'USER.ADMIN' | translate}}
                  </label>
                </div>
                <div class="form-check form-switch">
                  <input mdbCheckbox class="form-check-input" type="checkbox" value="'EDITOR'" id="editor" name="editor"
                    [checked]="user?.roles && user?.roles.includes('EDITOR')" (change)="onCheckboxChange($event,'EDITOR')" />
                    <label class="form-check-label" for="flexCheckDefault">
                      - {{'USER.EDITOR' | translate}}
                    </label>
                  </div>
                  <div class="form-check form-switch">
                    <input mdbCheckbox class="form-check-input" type="checkbox" value="'VIEWER'" id="viewer" name="viewer"
                      [checked]="user?.roles && user?.roles.includes('VIEWER')" (change)="onCheckboxChange($event,'VIEWER')" />
                      <label class="form-check-label" for="flexCheckDefault">
                        - {{'USER.VIEWER' | translate}}
                      </label>
                    </div>
                    <div class="form-check form-switch">
                      <input mdbCheckbox class="form-check-input" type="checkbox" value="'REGIONAL_OFFICER'" id="regionalOfficer"
                        name="regionalOfficer" [checked]="user?.roles && user?.roles.includes('REGIONAL_OFFICER')"
                        (change)="onCheckboxChange($event,'REGIONAL_OFFICER')" />
                        <label class="form-check-label" for="flexCheckDefault">
                          - {{'USER.REGIONAL_OFFICER' | translate}}
                        </label>
                      </div>
                      <div class="form-check form-switch">
                        <input mdbCheckbox class="form-check-input" type="checkbox" value="'DIRECTOR_GENERAL'" id="directorGeneral"
                          name="directorGeneral" [checked]="user?.roles && user?.roles.includes('DIRECTOR_GENERAL')"
                          (change)="onCheckboxChange($event,'DIRECTOR_GENERAL')" />
                          <label class="form-check-label" for="flexCheckDefault">
                            - {{'USER.DIRECTOR_GENERAL' | translate}}
                          </label>
                        </div>
                        <div class="form-check form-switch">
                          <input mdbCheckbox class="form-check-input" type="checkbox" value="'DIRECTOR_APPROVER'"
                            id="directorApprover" name="directorApprover"
                            [checked]="user?.roles && user?.roles.includes('DIRECTOR_APPROVER')"
                            (change)="onCheckboxChange($event,'DIRECTOR_APPROVER')" />
                            <label class="form-check-label" for="flexCheckDefault">
                              - {{'USER.DIRECTOR_APPROVER' | translate}}
                            </label>
                          </div>
                          <div class="form-check form-switch">
                            <input mdbCheckbox class="form-check-input" type="checkbox" value="'INSPECTOR'" id="inspector"
                              name="inspector" [checked]="user?.roles && user?.roles.includes('INSPECTOR')"
                              (change)="onCheckboxChange($event,'INSPECTOR')" />
                              <label class="form-check-label" for="flexCheckDefault">
                                - {{'USER.INSPECTOR' | translate}}
                              </label>
                            </div>
                            <div class="form-check form-switch">
                              <input mdbCheckbox class="form-check-input" type="checkbox" value="'CHEF'" id="chef"
                                name="chef" [checked]="user?.roles && user?.roles.includes('CHEF')"
                                (change)="onCheckboxChange($event,'CHEF')" />
                                <label class="form-check-label" for="flexCheckDefault">
                                  - {{'USER.CHEF' | translate}}
                                </label>
                              </div>
                              <div class="form-check form-switch">
                                <input mdbCheckbox class="form-check-input" type="checkbox" value="'COORDINATOR'" id="coordinator"
                                  name="coordinator" [checked]="user?.roles && user?.roles.includes('COORDINATOR')"
                                  (change)="onCheckboxChange($event,'COORDINATOR')" />
                                  <label class="form-check-label" for="flexCheckDefault">
                                    - {{'USER.COORDINATOR' | translate}}
                                  </label>
                                </div>
                                <div class="form-check form-switch">
                                  <input mdbCheckbox class="form-check-input" type="checkbox" value="'CONTROLLER'" id="controller"
                                    name="controller" [checked]="user?.roles && user?.roles.includes('CONTROLLER')"
                                    (change)="onCheckboxChange($event,'CONTROLLER')" />
                                    <label class="form-check-label" for="flexCheckDefault">
                                      - {{'USER.CONTROLLER' | translate}}
                                    </label>
                                  </div>
                                </div>
                              }


                              <div class="form-group mb-4">
                                <label for="rattachementList">{{'USER.TAX_OFFICES' | translate}}</label>
                                <ntr-multiple-select #rattachementListSelect
                                  [items]="isAdmin ? rattachementList : user.rattachementList"
                                  [key]="'abrev'" [placeholder]="'Tax office(s)'" [display]="'abrev'"
                                  [activeItems]="user.rattachementList"
                                  [disabled]="!isAdmin">
                                </ntr-multiple-select>
                              </div>

                              <div class="form-group mb-4">
                                <label for="controlTypesList">{{'USER.CONTROL_TYPES' | translate}}</label>
                                <ntr-multiple-select #controlTypesListSelect
                                  [items]="isAdmin ? controlTypesList : user.controlTypesList"
                                  [key]="'controlTypes'" [placeholder]="'Control types'" [display]="'controlTypes'"
                                  [activeItems]="user.controlTypesList"
                                  [disabled]="!isAdmin">
                                </ntr-multiple-select>
                              </div>

                            </form>
                            @if (user.id) {
                              <br />
                            }

                            @if (user.id) {
                              <button class="btn btn-link" style="margin-top:15px; margin-bottom :15px; height: 40px; display:none;"
                              (click)="changePassBtnClick(true)">{{'USER.CHANGE_PASSWORD'|translate}}</button>
                            }

                            <!-- <div class="form-group" [ngClass]="currentPassword" *ngIf="changePass && !this.isAdmin">
                            <label for="currentPassword">{{'USER.CURRENT_PASSWORD' | translate}}</label>
                            <input type="password" class="form-control" id="currentPassword" [(ngModel)]="currentPassword" name="currentPassword">
                          </div> -->
                          @if (wrongCurrentPassword) {
                            <div style="color:red">{{'SETTINGS.WRONG_CURRENT_PASSWORD' | translate}}</div>
                          }

                          @if (changePass || !user.id) {
                            <div class="form-group" [ngClass]="{'was-validated': (pass1===pass2 && pass1!=='')}"
                              >
                              <label for="pass1">{{'USER.PASSWORD' | translate}}</label>
                              <input type="password" class="form-control" id="pass1" [(ngModel)]="pass1" name="pass1">
                            </div>
                          }

                          @if (changePass || !user.id) {
                            <div class="form-group" [ngClass]="{'was-validated': (pass1===pass2 && pass1!=='')}"
                              >
                              <label for="pass2">{{'USER.REPEAT_PASSWORD' | translate}}</label>
                              <input type="password" class="form-control" id="pass2" [(ngModel)]="pass2" name="pass2">
                            </div>
                          }
                          @if (pass1!==pass2) {
                            <div style="color:red">{{'USER.PASSWORD_MISMATCH'|translate}}</div>
                          }
                          @if (changePass) {
                            <button class="btn btn-primary" style="margin-top:15px; margin-bottom :15px; height: 40px;"
                            (click)="updatePassword(true)">{{'USER.UPDATE_PASSWORD'|translate}}</button>
                          }

                        </div>

                      </div>

                    </div>
                    <ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="var(--fg-on-navy)" type="ball-scale-multiple">
                      <p style="font-size: 20px; color: white; text-align: center;">{{'UTIL.LOADING' | translate}}...</p>
                    </ngx-spinner>
